'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _projects = require('redux/modules/projects');

var projectsActions = _interopRequireWildcard(_projects);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ProjectsList = require('components/Projects/ProjectsList/ProjectsList');

var _ProjectsList2 = _interopRequireDefault(_ProjectsList);

var _auth = require('selectors/auth');

var _projects2 = require('helpers/projects');

var _Pagination = require('components/Pagination/Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _projects3 = require('selectors/projects');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var scroll = _reactScroll2.default.animateScroll;

var ProjectsListWrapper = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  var projectsEntities = (0, _projects3.getProjects)(state, ownProps);
  return {
    activeOrder: state.projects.activeOrder,
    order: state.projects.order,
    projects: projectsEntities.projects,
    projectsCount: projectsEntities.countAll,
    projectsListPage: state.projects.projectsListPage,
    projectsListPagesCount: state.projects.projectsListPagesCount,
    projectsLoading: state.projects.projectsLoading,
    deleteProjectLoaders: state.projects.deleteProjectLoaders,
    userPermissions: (0, _auth.getPermissions)(state)
  };
}, (0, _extends3.default)({}, projectActions, projectsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectsListWrapper, _Component);

  function ProjectsListWrapper() {
    (0, _classCallCheck3.default)(this, ProjectsListWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectsListWrapper.__proto__ || (0, _getPrototypeOf2.default)(ProjectsListWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectsListWrapper, [{
    key: 'onEdit',
    value: function onEdit() {
      this.props.initProject();
    }
  }, {
    key: 'onDelete',
    value: function onDelete(project) {
      this.props.deleteProject(project.id, project.projectContentType);
    }
  }, {
    key: 'onCreateSubproject',
    value: function onCreateSubproject() {
      this.props.initProject();
    }
  }, {
    key: 'onPageChange',
    value: function onPageChange(_ref) {
      var page = _ref.page;

      this.props.setProjectsListPage({ page: page });
      scroll.scrollToTop();
    }
  }, {
    key: 'reorder',
    value: function reorder(name) {
      this.props.reorder(name);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          projectsLoading = _props.projectsLoading,
          projects = _props.projects,
          showTypeColumn = _props.showTypeColumn,
          showActionsColumn = _props.showActionsColumn,
          deleteProjectLoaders = _props.deleteProjectLoaders,
          activeOrder = _props.activeOrder,
          order = _props.order,
          userPermissions = _props.userPermissions,
          projectsListPage = _props.projectsListPage,
          projectsCount = _props.projectsCount;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ProjectsList2.default, {
          activeOrder: activeOrder,
          order: order,
          onReorder: this.reorder,
          projects: projects,
          onDelete: this.onDelete,
          onCreateSubproject: this.onCreateSubproject,
          onEdit: this.onEdit,
          showTypeColumn: showTypeColumn,
          showActionsColumn: showActionsColumn,
          deleteLoaders: deleteProjectLoaders,
          loading: projectsLoading,
          userPermissions: userPermissions
        }),
        _react2.default.createElement(_Pagination2.default, {
          className: 'margin-top-20 text-right',
          count: projectsCount,
          page: projectsListPage,
          limit: _projects2.pageLimit,
          onChange: this.onPageChange
        })
      );
    }
  }]);
  return ProjectsListWrapper;
}(_react.Component), _class3.propTypes = {
  activeOrder: _propTypes2.default.string,
  deleteProject: _propTypes2.default.func,
  deleteProjectLoaders: _propTypes2.default.object,
  initProject: _propTypes2.default.func,
  order: _propTypes2.default.object,
  projects: _propTypes2.default.array.isRequired,
  projectsCount: _propTypes2.default.number,
  projectsListPage: _propTypes2.default.number,
  projectsLoading: _propTypes2.default.bool,
  reorder: _propTypes2.default.func,
  setProjectsListPage: _propTypes2.default.func,
  showActionsColumn: _propTypes2.default.bool,
  showTypeColumn: _propTypes2.default.bool,
  userPermissions: _propTypes2.default.object
}, _class3.defaultProps = {
  projects: [],
  projectsLoading: false,
  showActionsColumn: false,
  showTypeColumn: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onEdit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onEdit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCreateSubproject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCreateSubproject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPageChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPageChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype)), _class2)) || _class);
exports.default = ProjectsListWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/ProjectsListWrapper/ProjectsListWrapper.js
// module id = 2067
// module chunks = 1